export const categoryDetails = [
    {
        id: 1,
        default: require('@/assets/眼眉/3_2.jpg'),
        active: require('@/assets/眼眉/3_2.jpg'),
        describe1: '纤长炫翘双头睫毛膏',
        describe2: '天生纤长 卷翘分明',
        links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.66.211ce061aTO53u&id=618771930343&rn=21eac649d07a552aa57ace9289aa5bd4&abbucket=17&skuId=4536631814968'
    },
    {
        id: 2,
        default: require('@/assets/眼眉/3_3.jpg'),
        active: require('@/assets/眼眉/3_3.jpg'),
        describe1: '「小花棒」纤长睫毛膏',
        describe2: '小巧刷头 温水可卸',
        links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.71.211ce061aTO53u&id=616652670173&rn=21eac649d07a552aa57ace9289aa5bd4&abbucket=17'
    },
    {
        id: 3,
        default: require('@/assets/眼眉/3_1.jpg'),
        active: require('@/assets/眼眉/3_1.jpg'),
        describe1: '立体卷翘金属睫毛膏',
        describe2: '硬核钢管 一刷定住太阳花',
        links: 'https://detail.tmall.com/item.htm?app=chrome&bxsign=scdvhV7pZU4cpvP71QGUwf0yBoLTLkCQY2U1cuFG21ZIpJnk_53OBLxwM9CGyeo4XJ1tQtp9sVx5QILZ7N70FBS9hqjNAS94DI-PGlSETj0Ar9bYX7EBcVwSgi051-tISmN&cpp=1&id=653519512729&origin_price=79&price=49.8&shareUniqueId=19939623001&share_crt_v=1&shareurl=true&short_name=h.UnwZ3it&sourceType=item&sp_abtk=gray_1_code_simpleios2&sp_tk=TEpDMGQ2a0JOMjk=&spm=a2159r.13376460.0.0&suid=C2CC0FC5-8BB4-4823-8E4C-4F549B45499F&tbSocialPopKey=shareItem&tk=LJC0d6kBN29&un=26037f64cf4c5ce5b2a02c4eb1ea31ed&un_site=0&ut_sk=1.X97pKKL5aq8DAOKGXjarDDr1_21380790_1675758178488.Copy.1&sku_properties=147956252:75366757'
    }
]